import { PlusOutlined } from '@ant-design/icons'
import type { components } from '@fluencelabs/vodopad-admin-api'
import { useTable } from '@refinedev/antd'
import { type HttpError, useNavigation } from '@refinedev/core'
import { Breadcrumb, Button, Table } from 'antd'
import { useState } from 'react'

import { UsersCacheProvider } from '@/hooks/useUsersByIds'
import { getPersistedPageSize, tablePaginationConfig } from '@/types/api'

import { intentColumns } from './columns'
import { AttestDepositModal } from './components/AttestDepositModal'
import { PaymentsFilterForm } from './components/PaymentsFilterForm'

type AdminIntentDto = components['schemas']['AdminIntentDto']

interface PaymentFilters {
  status?: string
  userId?: string
  provider?: string
  methodCode?: string
}

export default function PaymentsListPage() {
  const { show } = useNavigation()
  const [attestOpen, setAttestOpen] = useState(false)

  const { tableProps, searchFormProps, filters } = useTable<
    AdminIntentDto,
    HttpError,
    PaymentFilters
  >({
    resource: 'payments',
    pagination: { pageSize: getPersistedPageSize() },
    syncWithLocation: true,
    onSearch: (values) => [
      { field: 'status', operator: 'eq', value: values.status || undefined },
      { field: 'userId', operator: 'eq', value: values.userId || undefined },
      {
        field: 'provider',
        operator: 'eq',
        value: values.provider || undefined,
      },
      {
        field: 'methodCode',
        operator: 'eq',
        value: values.methodCode || undefined,
      },
    ],
  })

  return (
    <div>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[{ title: 'Payments' }]}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 16,
        }}
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setAttestOpen(true)}
        >
          Attest deposit
        </Button>
      </div>

      <PaymentsFilterForm searchFormProps={searchFormProps} filters={filters} />

      <UsersCacheProvider
        ids={(tableProps.dataSource ?? []).map((i) => i.userId)}
      >
        <Table
          {...tableProps}
          pagination={tablePaginationConfig(tableProps)}
          rowKey="intentId"
          onRow={(record) => ({
            onClick: (e) => {
              const target = e.target as HTMLElement
              if (target.closest('.ant-typography-copy') || target.closest('a'))
                return
              show('payments', record.intentId)
            },
            style: { cursor: 'pointer' },
          })}
          columns={intentColumns()}
          scroll={{ x: 1260 }}
        />
      </UsersCacheProvider>

      <AttestDepositModal
        open={attestOpen}
        onClose={() => setAttestOpen(false)}
      />
    </div>
  )
}
